/**
 * A page the API reduced to a stub for this viewer (PRIVACY_PLAN.md §4.1):
 * tells search engines to leave it out. unhead dedupes meta by name, so this
 * replaces the site-wide robots tag from plugins/seo-robots.js while it is on.
 *
 * @param {import('vue').Ref|import('vue').ComputedRef} isPrivate
 */
export function usePrivatePage(isPrivate) {
  useHead({
    meta: computed(() => isPrivate.value ? [{name: 'robots', content: 'noindex, nofollow'}] : []),
  });
}
